import classNames from 'classnames';
import React from 'react';
import { DivMouseHandler } from './types/commonPropTypes';

type ListOptionsProps = {
  title: string;
  selected: boolean;
  onClick: DivMouseHandler;
  onDoubleClick?: DivMouseHandler;
  className?: string;
  iconClassName?: string;
  icon?: React.ReactNode;
  titleClassName?: string;
};

export default function ListOption(props: ListOptionsProps) {
  const classes = classNames(
    'group flex flex-col justify-self-center m-4 cursor-pointer relative template-container ev-sm-max:max-w-[100px]',
    props.className,
    {
      active: props.selected
    }
  );

  const titleClasses = classNames('mt-[10px] font-base text-center text-ev-navy-blue-2', props.titleClassName, {
    ['no-underline font-bold text-ev-navy-blue-2']: props.selected,
    ['font-medium	underline group-hover:text-ev-baby-blue-2']: !props.selected
  });

  return (
    <div className={classes} onClick={props.onClick} onDoubleClick={props.onDoubleClick}>
      <div className={`chart-template-thumbnail flex ${props.iconClassName}`}>{props.icon}</div>
      <div className={titleClasses}>{props.title}</div>
    </div>
  );
}
